export default __webpack_public_path__ + "static/media/demo1.5945eb9a.mp4";